import { render, staticRenderFns } from "./StudiosPage.vue?vue&type=template&id=5674db2c&scoped=true"
import script from "./StudiosPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudiosPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudiosPage.vue?vue&type=style&index=0&id=5674db2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5674db2c",
  null
  
)

export default component.exports